import type { GeoJsonFeatureCollection } from "../../core/types/geojson";
import { createTimestampedFileName, downloadTextFile } from "../../core/utils/file";
import { GeoJsonParser } from "./GeoJsonParser";

export class GeoJsonExporter {
  static download(document: GeoJsonFeatureCollection, prefix = "map_features"): void {
    downloadTextFile(createTimestampedFileName(prefix, "geojson"), GeoJsonParser.stringify(document), "application/geo+json");
  }
}
